import { Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';
import { CheckboxComponent } from "@shared/controls/checkbox/checkbox.component";
import { DocumentSelection } from "@models/documents/document-selection";
import { DocumentationType } from "@models/documents/document-enums";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";
import { isDocumentVisible } from "./utils/is-document-visible";
import { CdkDrag, CdkDragDrop, CdkDropList, moveItemInArray } from "@angular/cdk/drag-drop";

@Component({
  selector: 'app-document-selection',
  standalone: true,
  imports: [
    CheckboxComponent,
    NgxSkeletonLoaderModule,
    CdkDropList,
    CdkDrag
  ],
  templateUrl: 'document-selection.component.html',
  styleUrl: 'document-selection.component.scss'
})
export class DocumentSelectionComponent implements OnInit {
  @Input() controlId = 'document-selection-component-'
  @Input() title = '';
  @Input() documentationType: DocumentationType | undefined;
  @Input() isDisabled = false;

  @Input() set documentSelectionList(value: DocumentSelection[] | undefined) {
    if (value === undefined) { return; }
    this.selection = value.sort((a, b) => a.sequence - b.sequence);
  }

  @Output() documentSelectionChange = new EventEmitter<DocumentSelection[]>();

  @HostBinding('class.display-none') get hasDocuments() {
    return !this.selection.length;
  }

  selection: DocumentSelection[] = [];

  ngOnInit(): void {
    if (this.isDisabled) {
      return;
    }
  }

  onCheckboxChange(selected: boolean, activeDocumentSelection: DocumentSelection): void {
    this.selection = this.selection.map(selection => ({
      ...selection,
      included: (selection.fileId && selection.fileId === activeDocumentSelection.fileId || selection.fileName && selection.fileName === activeDocumentSelection.fileName) ? selected : selection.included,
    }));
    this.documentSelectionChange.emit(this.selection);
  }

  onFileDropped(event: CdkDragDrop<any>): void {
    moveItemInArray(this.selection, event.previousIndex, event.currentIndex);
    this.selection = this.selection.map((documentSelection, index) => ({
      ...documentSelection,
      sequence: index + 1,
    }));
    this.documentSelectionChange.emit(this.selection);
  }

  protected readonly isDocumentVisible = isDocumentVisible;
}
